/** One container width and one left edge, shared by the header rows and every page. */
export const SHELL_CONTAINER = 'mx-auto w-full max-w-[1600px] px-4 md:px-6 lg:px-8';

/** Wide data pages (tables wider than 1600px) use the full window; the header follows so the left edge stays shared. */
const SHELL_CONTAINER_WIDE = 'w-full px-4 md:px-6 lg:px-8';
const WIDE_PATHS = ['/replenishment/report'];

export function shellContainer(pathname: string): string {
  return WIDE_PATHS.some(p => pathname === p || pathname.startsWith(`${p}/`)) ? SHELL_CONTAINER_WIDE : SHELL_CONTAINER;
}
